export default class Idle
{
  constructor()
  {
  }

  get is_animating()
  {
    return false;
  }

  on_enter(view)
  {

  }

  update(view)
  {
  }

  on_exit(view)
  {

  }
}
